import Vue from 'vue'
import Router from 'vue-router'

import authRouter from './modules/auth'
import manageClazzRouter from './modules/manageclazz'
import clazzRouter from './modules/clazz'
import raceRouter from './modules/race'
import dakaRouter from './modules/daka'
import orderRouter from './modules/order'
import recordRouter from './modules/record'
import notificationRouter from './modules/notification'
import myRouter from './modules/my'

Vue.use(Router)

const constantRouterMap = [
  ...authRouter,
  ...manageClazzRouter,
  ...clazzRouter,
  ...raceRouter,
  ...dakaRouter,
  ...orderRouter,
  ...recordRouter,
  ...notificationRouter,
  ...myRouter,
  {
    path: '/preview/poster',
    name: 'poster',
    meta: {
      noAuth: true
    },
    component: () => import('@/views/preview/poster.vue')
  },
  {
    path: '/preview/clazz_card',
    name: 'clazzcard',
    meta: {
      noAuth: true
    },
    component: () => import('@/views/preview/clazz_card.vue')
  },
  {
    path: '',
    component: () => import('@/views/layout/Layout.vue'),
    redirect: '/',
    children: [
      {
        path: '/',
        name: 'home',
        component: () => import('@/views/home/index.vue')
      },
      {
        path: '/explore',
        name: 'explore',
        component: () => import('@/views/explore/list.vue'),
        meta: {
          noAuth: true
        }
      },
      {
        path: '/daka',
        name: 'daka',
        component: () => import('@/views/record/daka.vue')
      },
      {
        path: '/notification',
        name: 'notification',
        component: () => import('@/views/notification/list.vue')
      },
      {
        path: '/my',
        name: 'my',
        component: () => import('@/views/my/my.vue')
      }
    ]
  }
]

export default new Router({
  mode: 'history',
  base: process.env.VUE_APP_ROUTER_BASE,
  routes: constantRouterMap
})
